module.exports = __webpack_public_path__ + "static/media/h1.6a03c92a.jpg";